



























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

import Popup from '@/components/Popups/Popup.vue';

@Component({
    components: {
        Popup
    },
    model: {
        prop: "model",
        event: "visibilityChanged"
    }
})
export default class TermsPopup extends Vue {
    public visibility = false;
        
    // Properties
    @Prop({ required: false })
    public model?: boolean;

    @Prop({ required: false, type: Boolean, default: true })
    public consumer!: boolean;

    // Getter & Setter
    public get visible(): boolean {
        return this.model ?? this.visibility;
    }
    public set visible(value: boolean) {
        this.visibility = value;
        this.$emit('visibilityChanged', value);
    }

    // Watcher

    // Lifecycle Methods:

    // Methods:
    public close(): void {
        this.visible = false;
    }
}
